import { db } from "../services/firebase";

import {
  getQueryData,
  getQueryDataDocs,
  addDataToDb,
  addToArray,
  setDataInDb,
  removeFromArray,
  updateDataInDb,
} from "./db";

import firebase from "firebase/app";

import {
  userTypes,
  // Color,
  randomColorHSL,
  // WorkshopData,
  TeamData,
  BoardData,
  InstitutionData,
  // BoardMessageData
} from "../helpers/Types";

import {
  //createNewUser,
  createUserInDb,
} from "../helpers/userManagement";
import { openaiAddTagsMessage, openaiGetReplyMessage } from "./openai";

export async function deleteUser(userId) {
  if (!userId) return;
  try {
    await db.collection("users").doc(userId).delete();
  } catch (error) {
    console.error("Error removing document: ", error);
  }
}

export async function createTeam(teamName, workshopId) {
  const newTeam = await addDataToDb(
    "teams",
    TeamData(teamName, workshopId),
    true,
    "id"
  );
  await createBoard("Your board", newTeam.id);
  return newTeam.id;
}

// export function makeDefaultBoard(){
// 	setDataInDb('boards', 'default',{
//         id: "default",
//     messages: [],
//     teamId:null,
//     name: "",
//     color: randomColorHSL(),
//     created: firebase.firestore.FieldValue.serverTimestamp(),
//         });
// }

export async function createBoard(boardName, teamId) {
  const newBoard = await addDataToDb(
    "boards",
    BoardData(teamId, boardName),
    true,
    "id"
  );
  if (newBoard) {
    const team = await db.collection("teams").doc(teamId).get();
    // console.log(team);
    if (team.exists) {
      team.data().members.forEach((m) => addBoardToUser(newBoard.id, m));
    }
  }
}

export async function removeBoard(boardId) {
  const users = await db
    .collection("users")
    .where("boards", "array-contains", boardId)
    .get();

  users.forEach((user) => removeBoardFromUser(boardId, user.id));

  db.collection("boards")
    .doc(boardId)
    .delete()
    .then(function () {
      console.log("Document successfully deleted!");
    })
    .catch(function (error) {
      console.error("Error removing document: ", error);
    });
}

function doIfUserExists(userId, func) {
  let userRef = db.collection("users").doc(userId);

  userRef
    .get()
    .then(function (doc) {
      if (doc.exists) {
        func(userRef, doc);
        // console.log("Document data:", doc.data());
      } else {
        // doc.data() will be undefined in this case
        // console.log("No such document!");
      }
    })
    .catch(function (error) {
      console.log("Error getting user:", error);
    });
}

export function addBoardToUser(boardId, userId) {
  doIfUserExists(userId, (userRef, userData) => {
    userRef.update({
      boards: firebase.firestore.FieldValue.arrayUnion(boardId),
    });
  });
}

export function removeBoardFromUser(boardId, userId) {
  doIfUserExists(userId, (userRef, userData) => {
    userRef.update({
      boards: firebase.firestore.FieldValue.arrayRemove(boardId),
    });
  });
}

export async function addUserToTeam(userId, teamId) {
  db.collection("teams")
    .doc(teamId)
    .update({
      members: firebase.firestore.FieldValue.arrayUnion(userId),
    });
  let boards = await db
    .collection("boards")
    .where("teamId", "==", teamId)
    .get();
  boards.forEach((b) => addBoardToUser(b.id, userId));
}

export async function removeUserFromTeam(userId, teamId) {
  db.collection("teams")
    .doc(teamId)
    .update({
      members: firebase.firestore.FieldValue.arrayRemove(userId),
    });
  let boards = await db
    .collection("boards")
    .where("teamId", "==", teamId)
    .get();
  boards.forEach((b) => removeBoardFromUser(b.id, userId));
}

export async function removeTeam(teamId) {
  let team = await getQueryData(db.collection("teams").doc(teamId));
  if (team) {
    let success = removeDoc("teams", teamId);
    if (success) {
      let boards = await db
        .collection("boards")
        .where("teamId", "==", teamId)
        .get();
      boards.forEach((b) => removeBoard(b.id));

      return true;
    }
  }
  return false;
}

export async function removeWorkshop(wsId) {
  console.log("removeWorkshop ", wsId);
  // return true;
  let team = await getQueryData(db.collection("workshops").doc(wsId));
  if (team) {
    let success = removeDoc("workshops", wsId);
    if (success) {
      let teams = await db
        .collection("teams")
        .where("workshopId", "==", wsId)
        .get();
      teams.forEach((b) => removeTeam(b.id));

      return true;
    }
  }
  return false;
}

export async function renameWorkshop(wsId, newName) {
  let ws = await getQueryData(db.collection("workshops").doc(wsId));
  if (ws) {
    // let success = removeDoc("teams", teamId);
    try {
      await db.collection("workshops").doc(wsId).update({ name: newName });
      return true;
    } catch (error) {
      console.log("Unable to rename Document " + wsId + " to : " + newName);
      return false;
    }
  }
  return false;
}

export async function setGooglePhotosLinkForWorkshop(wsId, gphotosLink) {
  let ws = await getQueryData(db.collection("workshops").doc(wsId));
  if (ws) {
    // let success = removeDoc("teams", teamId);
    try {
      await db
        .collection("workshops")
        .doc(wsId)
        .update({ googlePhotosLink: gphotosLink });
      return true;
    } catch (error) {
      console.log(
        "Unable set Google Photos Link For Workshop " +
          wsId +
          " : " +
          gphotosLink
      );
      return false;
    }
  }
  return false;
}

// const MAKE_DUMMY_USERS = false;

// export async  function createUser( userData, type, institutionId, workshopId)
// 	{
// if(MAKE_DUMMY_USERS){
// let uid = await createUserInDb(null, userData, type, institutionId, workshopId);
// return uid;
// }else{
// 	await createNewUser(userData, type, institutionId, workshopId);
// }
// return null;
// }

export async function createSchool(
  name,
  location,
  workshopId,
  instructors,
  students
) {
  // console.log("createSchool", name, location, workshopId, instructors, students)

  let instRef = await getQueryDataDocs(
    db.collection("institution").where("name", "==", name)
  );

  let instId = "";
  if (instRef) {
    instId = instRef.id;
  }
  if (instId === "" || instId === undefined) {
    let inst = await addDataToDb(
      "institution",
      InstitutionData(name, location),
      true,
      "id"
    );
    // console.log("createSchool", inst);
    if (inst) {
      instId = inst.id;
    } else {
      console.log("Failed creating school");
      return;
    }
  }
  // console.log("createSchool instId: ", instId);

  addToArray("workshops", workshopId, "institutions", instId);

  for (let i = 0; i < instructors.length; i++) {
    await createUserInDb(
      instructors[i],
      userTypes().instructor,
      instId,
      workshopId
    );
  }

  for (let i = 0; i < students.length; i++) {
    await createUserInDb(students[i], userTypes().student, instId, workshopId);
  }
}

export function addUserToWorkshop(userId, workshopId, userType) {
  if (!userId || !workshopId) return;

  if (userType === userTypes().instructor) {
    addToArray("workshops", workshopId, "instructors", userId);
  }

  if (userType === userTypes().student) {
    addToArray("workshops", workshopId, "students", userId);
  }
}

export function removeUserFromWorkshop(userId, workshopId, userType) {
  if (userType === userTypes().instructor) {
    removeFromArray("workshops", workshopId, "instructors", userId);
  }

  if (userType === userTypes().student) {
    removeFromArray("workshops", workshopId, "students", userId);
  }
}

export async function removeDoc(collectionId, docId) {
  try {
    await db.collection(collectionId).doc(docId).delete();
    return true;
  } catch (error) {
    console.log("Unable to remove Document " + collectionId + "." + docId);
    return false;
  }
}

export async function getPredefinedTags(type = "tags") {
  const documentName = "message" + type.charAt(0).toUpperCase() + type.slice(1);
  try {
    const predefinedTags = await getQueryData(
      db.collection("params").doc(documentName)
    );
    return predefinedTags.tags;
  } catch (error) {
    console.log("Unable to get predefined tags");
    return undefined;
  }
}

export async function setPredefinedTags(tags, type = "tags") {
  const documentName = "message" + type.charAt(0).toUpperCase() + type.slice(1);
  try {
    await updateDataInDb("params", documentName, { tags: tags });
  } catch (error) {
    console.log("Unable to set predefined tags");
  }
}

// export async function setMessagesBoard(tags, applytoAll = false) {
//   try {
//     const collectionRef = db.collection("boardMessages");
//     const querySnapshot = await collectionRef.get();

//     if (querySnapshot.empty) {
//       return { error: "No documents found in the collection" };
//     }

//     const updatePromises = querySnapshot.docs.map(async (snap) => {
//       const data = snap.data();
//       const message = data.content;
//       const id = data.id;
//       const docRef = collectionRef.doc(id);
//       if (!data.tags || applytoAll) {
//         let backoffTime = 1000;
//         try {
//           await openaiAddTagsMessage(docRef, message, tags);
//           await new Promise(resolve => setTimeout(resolve, backoffTime));
//           backoffTime *= 2;
//         } catch (error) {
//           if (error.response && error.response.status === 429) {
//             // Attendre et réessayer après un délai
//             await new Promise(resolve => setTimeout(resolve, backoffTime));
//             backoffTime *= 2;
//             await openaiAddTagsMessage(docRef, message, tags);
//           } else {
//             console.error("Erreur lors de l'ajout de tags:", error);
//           }
//         }
//       }
//     });

//     await Promise.all(updatePromises);

//     return { succeed: "Documents updated successfully" };
//   } catch (error) {
//     console.log("Unable to set message tags " + error);
//     return { error: error };
//   }
// }

export async function setMessagesBoard(
  type = "tags",
  tags,
  applytoAll = false,
  batchSize = 5,
  maxRetries = 3
) {
  const collections = ["boardMessages", "realtime"];
  const globalResults = {};

  for (const collectionName of collections) {
    try {
      const collectionRef = db.collection(collectionName);
      let querySnapshot = null;
      if (collectionName == "realtime") {
        querySnapshot = await collectionRef
          .where("isDeleted", "==", false)
          .get();
      } else {
        querySnapshot = await collectionRef.get();
      }

      if (querySnapshot.empty) {
        globalResults[collectionName] = {
          succeed: `No documents found in ${collectionName}`,
        };
        continue;
      }

      const docs = querySnapshot.docs.filter((doc) => {
        const data = doc.data();
        return !data[type] || data[type].length === 0 || applytoAll;
      });

      console.log(applytoAll, collectionName, querySnapshot.docs.length, docs.length);
      let i = 0;

      const results = {
        succeeded: [],
        failed: [],
        skipped: [],
      };

      async function processBatch(batch) {
        const promises = batch.map(async (doc) => {
          const data = doc.data();
          const message = data.content || data.Body;
          const id = data.id;
          if (!id) {
            results.skipped.push(doc.id);
            return;
          }
          const docRef = collectionRef.doc(id);

          let retries = 0;
          let backoffTime = 1000;

          while (retries < maxRetries) {
            try {
              await openaiAddTagsMessage(docRef, message, tags, type);
              results.succeeded.push(id);
              await new Promise((resolve) => setTimeout(resolve, backoffTime));
              console.log(i);
              i++;
              break;
            } catch (error) {
              if (error.response && error.response.status === 429) {
                console.log(
                  `Rate limit reached on ${collectionName}. Waiting ${backoffTime}ms before retry...`
                );
                await new Promise((resolve) =>
                  setTimeout(resolve, backoffTime)
                );
                backoffTime *= 2;
                retries++;
                if (retries === maxRetries) {
                  results.failed.push(id);
                }
              } else {
                console.error(
                  `Error when adding tags on ${collectionName}:`,
                  error
                );
                results.failed.push(id);
                break;
              }
            }
          }
        });

        await Promise.all(promises);
      }

      for (let i = 0; i < docs.length; i += batchSize) {
        const batch = docs.slice(i, i + batchSize);
        await processBatch(batch);
      }

      globalResults[collectionName] = {
        succeed: `Batch processing completed on ${collectionName}`,
        results: results,
      };
    } catch (error) {
      console.log(`Unable to set message tags on ${collectionName}: `, error);
      globalResults[collectionName] = { error: error.toString() };
    }
  }

  return globalResults;
}

export async function setMessagesAnwser(
  batchSize = 5,
  maxRetries = 3
) {
  const collections = ["realtime"];
  const globalResults = {};

  for (const collectionName of collections) {
    try {
      const collectionRef = db.collection(collectionName);
      let querySnapshot = null;
      if (collectionName == "realtime") {
        querySnapshot = await collectionRef
          .where("isDeleted", "==", false)
          .get();
      } else {
        querySnapshot = await collectionRef.get();
      }

      if (querySnapshot.empty) {
        globalResults[collectionName] = {
          succeed: `No documents found in ${collectionName}`,
        };
        continue;
      }

      let docs = querySnapshot.docs.filter((doc) => {
        const data = doc.data();
        return !data["isCheckedByAnswerAI"];
      });

      docs = docs = docs.slice(0, 1);
      console.log(docs)

      let i = 0;
      const results = {
        succeeded: [],
        failed: [],
        skipped: [],
      };

      async function processBatch(batch) {
        const promises = batch.map(async (doc) => {
          const data = doc.data();
          const message = data.content || data.Body;
          const id = data.id;
          if (!id) {
            results.skipped.push(doc.id);
            return;
          }

          let retries = 0;
          let backoffTime = 1000;

          while (retries < maxRetries) {
            try {
              const replyMessage = await openaiGetReplyMessage(message);
              console.log(replyMessage)
              switch (replyMessage) {
                case "Harmful":
                case "harmful":
                case `"Harmful"`:
                case `"harmful"`:
                case "Harmful.":
                case "harmful.":
                case `"Harmful."`:
                case `"harmful."`:
                case "Political":
                case "political":
                case `"Political"`:
                case `"political"`:
                case "Political.":
                case "political.":
                case `"Political."`:
                case `"political."`:
                  await db.collection(collectionName).doc(id).update({
                    isDeleted: true,
                    isCheckedByAnswerAI: true,
                  });
                  break;
                case "Statement":
                case "statement":
                case `"Statement"`:
                case `"statement"`:
                case "Statement.":
                case "statement.":
                case `"Statement."`:
                case `"statement."`:
                  await db.collection(collectionName).doc(id).update({
                    isCheckedByAnswerAI: true,
                  });
                  break;
                default:
                  const alreadyAnsweredSnapshot = await db.collection(collectionName)
                    .where("replyingTo", "==", id)
                    .where("ProfileName", "==", "AI Messenger")
                    .limit(1)
                    .get();
                  if (!alreadyAnsweredSnapshot.empty) {
                    results.skipped.push(id);
                    break;
                  }
                  await db.collection(collectionName).doc(id).update({
                    isCheckedByAnswerAI: true,
                  });
                  const answerAI = {
                    Body: replyMessage,
                    ProfileName: "AI Messenger",
                    timestamp: firebase.firestore.FieldValue.serverTimestamp(),
                    wasShown: false,
                    isShowing: false,
                    isDeleted: false,
                    isRealTime: true,
                    isCheckedByAnswerAI: true,
                    replyingTo: id,
                  };
                  let docRefAnswerAI = await db.collection(collectionName).add(answerAI);
                  await db.collection(collectionName).doc(docRefAnswerAI.id).update({
                    id: docRefAnswerAI.id,
                  });
                  break;
              }

              results.succeeded.push(id);
              await new Promise((resolve) => setTimeout(resolve, backoffTime));
              console.log(i);
              i++;
              break;
            } catch (error) {
              if (error.response && error.response.status === 429) {
                console.log(
                  `Rate limit reached on ${collectionName}. Waiting ${backoffTime}ms before retry...`
                );
                await new Promise((resolve) =>
                  setTimeout(resolve, backoffTime)
                );
                backoffTime *= 2;
                retries++;
                if (retries === maxRetries) {
                  results.failed.push(id);
                }
              } else {
                console.error(
                  `Error when adding tags on ${collectionName}:`,
                  error
                );
                results.failed.push(id);
                break;
              }
            }
          }
        });

        await Promise.all(promises);
      }

      for (let i = 0; i < docs.length; i += batchSize) {
        const batch = docs.slice(i, i + batchSize);
        await processBatch(batch);
      }

      globalResults[collectionName] = {
        succeed: `Batch processing completed on ${collectionName}`,
        results: results,
      };
    } catch (error) {
      console.log(`Unable to set message answer AI on ${collectionName}: `, error);
      globalResults[collectionName] = { error: error.toString() };
    }
  }

  return globalResults;
}
